import { api } from "..";
import {
  AuthResult,
  ConfirmEmailResponse,
  ForgotPasswordRequest,
  LoginRequest,
  ResetPasswordRequest,
  SsoAuthUrlResponse,
  SsoInitiateRequest,
  UpdatePasswordRequest,
  VerifyCodeRequest,
} from "../../types/domain";

export const login = async (dto: LoginRequest): Promise<AuthResult> => {
  const response = await api.post<AuthResult>("/account/login", dto);
  return response.data;
};

export const verifyCode = async (dto: VerifyCodeRequest): Promise<AuthResult> => {
  const response = await api.post<AuthResult>("/account/verify-code", dto);
  return response.data;
};

export const updatePassword = async (dto: UpdatePasswordRequest): Promise<AuthResult> => {
  const response = await api.post<AuthResult>("/account/update-password", dto);
  return response.data;
};

export const forgotPassword = async (dto: ForgotPasswordRequest): Promise<void> => {
  await api.post("/account/forgot-password", dto);
};

export const resetPassword = async (dto: ResetPasswordRequest): Promise<AuthResult> => {
  const response = await api.post<AuthResult>("/account/reset-password", dto);
  return response.data;
};

export const ssoInitiate = async (dto: SsoInitiateRequest): Promise<SsoAuthUrlResponse> => {
  const response = await api.post<SsoAuthUrlResponse>("/account/sso/initiate", dto);
  return response.data;
};

export const confirmEmail = async (confirmation: string): Promise<ConfirmEmailResponse> => {
  const response = await api.get<ConfirmEmailResponse>(`/account/confirm-email`, {
    params: { confirmation },
  });
  return response.data;
};
